<app-loading-guard [loading]="entityList.loading">
  <div class="gateway-list-container">
    <app-gateway-alerts-list
      [entityList]="entityList"
      [displayedColumns]="displayedColumns"
      (pageEvent)="onPageEvent($event)"
    ></app-gateway-alerts-list>
  </div>
</app-loading-guard>
